/**
 * Email Drag Controller — stub.
 *
 * Drag-and-drop is now handled by EmailDragManager (a pure JS module)
 * using event delegation on the root email layout element. This stub
 * prevents Stimulus "unknown controller" warnings from any legacy ERB
 * partials that still reference data-controller="email-drag".
 *
 * All drag logic has been moved to:
 *   app/javascript/modules/email/email-drag-manager.js
 */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {}
